import { type VarUser } from '@blaze-shared/schema-domain';

/**
 * @returns User initials based on provided user name.
 */
export function getUserInitials(name?: string | null): string {
  if (typeof name !== 'string') {
    return '';
  }
  name = name.trim();

  const nameParts = name.split(' ');
  const firstInitial = nameParts[0]?.[0] || '';
  const lastInitial = nameParts?.length >= 2 ? nameParts.at(-1)?.[0] || '' : '';

  return `${firstInitial}${lastInitial}`.toUpperCase();
}

/**
 * @returns User initials based on the value found in User object under specified column.
 */
export function getUserInitialsFromColumn(
  user: VarUser | undefined,
  initialsCol: string | undefined,
): string {
  let name = '';
  if (user && initialsCol && user?.[initialsCol]) {
    name = `${user?.[initialsCol]}`;
  }
  return getUserInitials(name);
}
